import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { environment } from 'src/environments/environment.prod';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ThemeService } from "src/app/services/theme.service";
import { GlobalProvider } from 'src/app/services/backnavigation';
import { TranslateService } from '@ngx-translate/core';
import { FontService } from 'src/app/services/font.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DataService } from 'src/app/services/data.service';
import * as jwtDecode from 'jwt-decode';
import { UserSession } from 'src/app/models/usersession';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleService } from 'src/app/services/role.service';
import { ToastrService } from 'ngx-toastr';
import { RoleType } from 'src/enum/roletype';
import { Router } from '@angular/router';
import swal from "sweetalert2";
import { AlertService } from 'src/app/services/alert.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { LaptopschemepopupComponent } from '../laptopschemepopup/laptopschemepopup.component';
import { LaptopschemeDataComponent } from '../laptopscheme-data/laptopscheme-data.component';



@Component({
  selector: 'app-home',
  templateUrl: './home-landing.component.html',
  styleUrls: ['./home-landing.component.scss'],
  // imports: [MatSlideToggleModule],
})
export class HomeComponent implements OnInit {

  imageUrls: string[] = [
    'assets/images/landingpage.jpeg',
    'assets/images/educationbanner.jpg',
    // 'assets/images/landingpage.jpeg'
  ];
  activeIndex = 0;
  public publicUrl = environment.apipublicUrl;
  sessionData = new UserSession();

  lang: string;
  tamil: boolean;
  isLightTheme: boolean;
  isDarkTheme: boolean;
  darkModeActive: any;
  language: string;
  darktheme: boolean;
  roleId: any;
  roleEnumType = RoleType;
  isInstituteVerified: boolean;
  instituteCourseAvailable: boolean;


  currentYear = new Date().getFullYear();
  page: boolean;
  showBtn: boolean = false;


  constructor(
    private router: Router,
    public navigationService: NavigationService,
    private themeService: ThemeService,
    public translate: TranslateService,
    public pages: GlobalProvider,
    private fontService: FontService,
    private dataService: DataService,
    private sessionService: UserSessionService,
    private roleService: RoleService,
    private toaster: ToastrService,
    private alertService: AlertService,
    private userService: UserService,
    private authService: AuthenticationService,
    public dialog: MatDialog,



  ) {
    this.isDarkTheme = this.themeService.isDarkTheme;
    // if (JSON.parse(localStorage.getItem('isLoggedin')) === true) {
    //   // this.navigationService.goToDashboard();
    //   this.navigationService.goToHome();
    // }
    const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedin') || 'false');

    const urlParams = new URLSearchParams(window.location.search);
    const SSO_Id = urlParams.get('details') ?? "";
    const Ref_Id = urlParams.get('reference_id') ?? "";
    const Session_Id = urlParams.get('session_id') ?? "";

    localStorage.setItem('ssoId', SSO_Id);
    localStorage.setItem('sessionId', Session_Id);


    if (isLoggedIn === true) {
      this.navigationService.goToHome();
    } else if (SSO_Id && Ref_Id) {
      const formattedDetails = {
        encryptedData: SSO_Id,
        encrypted_token: Ref_Id

      };
      this.dataService.getSSOHomePage(formattedDetails).subscribe({
        next: (res) => {
          console.log('API Response:', res);
          if (res) {
            if (res.access_token) {
              // console.log("test", user);
              //this.clearSession();
              const decodedToken = jwtDecode(res.access_token);
              this.sessionData.userFullName = decodedToken['user.username'];
              this.sessionData.roleId = decodedToken['user.roleid'];
              this.sessionData.instituteId = decodedToken['user.instituteid'];
              this.sessionData.hodId = decodedToken['user.hodid'];
              this.sessionData.universityId = decodedToken['user.universityid'];
              this.sessionData.instituteownershipid = decodedToken['user.instituteownershipid'];
              this.sessionData.institutetypeid = decodedToken['user.institutetypeid'];
              this.sessionData.userId = decodedToken['user.id'];
              this.sessionData.fullname = decodedToken['user.fullname'];
              this.sessionData.universityname = decodedToken['user.universityname'] === '0' ? '' : decodedToken['user.universityname'];
              this.sessionData.departmentId = decodedToken['user.departmentId'];
              this.sessionData.districtId = decodedToken['user.districtId'];
              this.sessionData.rjdDistrictId = decodedToken['user.rjdDistrictId'];
              this.sessionData.ResetPasswordType = decodedToken['user.ResetPasswordType'];

              const instituteverified = decodedToken['user.instituteverified'];
              localStorage.setItem('instituteVerified', JSON.stringify(instituteverified === 'True' ? true : false));

              const instituteCourseAvailable = decodedToken['user.instituteCourseAvailable'];
              localStorage.setItem('instituteCourseAvailable', JSON.stringify(instituteCourseAvailable === 'True' ? true : false));

              this.sessionData.authToken = res.access_token;
              if (this.sessionData.roleId == "9") {
                debugger;
                this.sessionData.studentId = decodedToken['user.studentId'];
                this.sessionData.umisId = decodedToken['user.umisId'];
                this.sessionData.DOB = decodedToken['user.DOB'];
                this.sessionData.Gender = decodedToken['user.Gender'];
                this.sessionData.PassportNumber = decodedToken['user.PassportNumber'];
                this.sessionData.aadhaarnumber = decodedToken['user.aadhaarnumber'];
                this.sessionData.isekycdone = decodedToken['user.isekycdone'];
                this.sessionData.nodalofficername = decodedToken['user.nodalofficername'];
                this.sessionData.studentName = decodedToken['user.studentName'];
                this.sessionData.emisId = decodedToken['user.emisId'];
                this.sessionData.eligiblefortransfer = decodedToken['user.eligiblefortransfer'];
                this.sessionData.originUrl = window.location.origin;
                localStorage.setItem('initiateStudent', 'true');
              }
              this.sessionService.create(this.sessionData);
            }
            this.getMenu(true);

          } else {
            console.warn('SSO verification failed');
          }
        },
        error: (err) => {
          console.error('API call failed:', err);
        }
      });

    }

    this.pages.language
    this.translate.use(this.pages.language);
  }

  ngOnInit(): void {
    this.language = "English"
    this.LaptopGrievanceEligible();
  }

  languagechange() {
    this.tamil = !this.tamil
    if (!this.tamil) {
      this.language = "English"
      this.translate.use('en');
      this.lang = 'en'
      this.pages.language = this.lang;
    } else {
      this.language = "தமிழ்"
      this.translate.use('ta');
      this.lang = 'ta'
      this.pages.language = this.lang;
    }
  }

  onThemeSwitchChange() {
    this.isLightTheme = !this.isLightTheme;

    document.body.setAttribute(
      'data-theme',
      this.isLightTheme ? 'light' : 'dark'
    );
  }

  // gotodark(event){
  //   if(event.chcked){
  //     window.location.reload();
  //     this.isDarkTheme = true;
  //     this.themeService.isDarkTheme;
  //   }
  // }
  toggleMode(event: any): void {
    this.darkModeActive = event.target.checked;
    this.themeService.setDarkMode(this.darkModeActive);
  }

  onToggleChange(event: any) {
    if (event.checked) {
      this.darktheme = true;
    } else {
      this.darktheme = false;
    }
    // You can perform any action here based on the toggle state
  }


  nextSlide() {
    this.activeIndex = (this.activeIndex + 1) % this.imageUrls.length; // Increment the active index
  }

  prevSlide() {
    this.activeIndex = (this.activeIndex - 1 + this.imageUrls.length) % this.imageUrls.length; // Decrement the active index
  }

  increaseFontSize(): void {
    this.fontService.increaseFontSize();
  }

  decreaseFontSize(): void {
    this.fontService.decreaseFontSize();
  }

  resetFontSize(): void {
    this.fontService.resetFontSize();
  }

  getMenu(isRefresh) {
    this.roleService.getMenu(isRefresh).subscribe((result) => {
      const menuItems = [];
      result.forEach((element) => {
        const mainMenu = { label: element.title, icon: element.icon, link: element.path, isVisible: element.isVisible, subItems: [] };
        if (element.submenu && element.submenu.length > 0) {
          element.submenu.forEach((level1) => {
            const submenu1 = { label: level1.title, icon: level1.icon, link: level1.path, isVisible: level1.isVisible, subItems: [] };
            if (level1.submenu && level1.submenu.length > 0) {
              level1.submenu.forEach((level2) => {
                const submenu2 = { label: level2.title, icon: level2.icon, link: level2.path, isVisible: level2.isVisible, subItems: [] };
                if (level2.submenu && level2.submenu.length > 0) {
                  level2.submenu.forEach((level3) => {
                    const submenu3 = { label: level3.title, icon: level3.icon, link: level3.path, isVisible: level3.isVisible, subItems: [] };
                    submenu2.subItems.push(submenu3);
                  });
                  submenu1.subItems.push(submenu2);
                }
              });
            }
            mainMenu.subItems.push(submenu1);
          });
        }
        menuItems.push(mainMenu);
      });
      if (menuItems && menuItems.length > 0) {
        this.sessionService.setLocalStorageWithKey("menu", menuItems);
        this.sessionService.setLocalStorageWithKey("menucontrols", result);

        if (this.roleId == this.roleEnumType.Student) {
          localStorage.setItem('isLoggedin', 'false');
          localStorage.setItem('isStudentLoggedin', 'true');
          this.toaster.success("Student Logged in Successfully!")
          var url = window.location.origin + "/student/";
          window.location.href = url;
          return;
        } else {
          localStorage.setItem('isLoggedin', 'true');
        }
        // this.navigation.goToDashboard();
        const selectedmenu = menuItems.find((e) => {
          if (this.roleId == this.roleEnumType.Intsitute && !this.isInstituteVerified) {
            return e.label === "Institute Information";
          }
          else if (this.roleId == this.roleEnumType.Intsitute && this.isInstituteVerified && !this.instituteCourseAvailable) {
            return e.label === "Course Information";
          }
          else {
            // return e.label === "Dashboard";
            return e.label === "Home";
          }
        });
        if (selectedmenu) {
          this.router.navigate([selectedmenu.link]);
          this.translate.defaultLang == "en"
            ? this.toaster.success("Logged in Successfully!", "UMIS")
            : this.translate.get("TOASTER.LOGGED_IN_SUCCESS").subscribe((res: string) => {
              this.toaster.success(res);
            });
          swal.fire({
            title: 'Info',
            html: `
                <ul class="text-justify p-0" style="font-size: 14px;color:black">
                     <li>
         <span style="color: red; font-weight: bold;">Kind Attention</span>: College Nodal Officers – Attendance Verification Module for Pudhumai Penn & Tamil Pudhalvan Schemes <br>(Q4: Oct - Dec 2025) is now OPEN. Last Date for Submission: 31.12.2025. Kindly update & verify attendance on time
  </li><br>
         <li>
    We request all institutes to submit their queries along with supporting proof through the Grievance Portal. For further enquiries, please contact our Toll-Free Number - 14417.
    <br>
    (Menu → Configuration → Grievance Redressal)
</li>
                  <li class="my-2">It has been decided that for the students who have completed their schooling inside Tamil Nadu, Student EMIS ID will be maintained</li>
                  <li>And for students who have done their schooling outside Tamil Nadu, a 9 series Student EMIS ID will be generated UMIS portal</li>
                </ul>
              `,
            icon: "info",
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok',
            allowOutsideClick: false,
          })
        }
        // else if (menuItems[0].subItems.length > 0) {
        // const firstmenu = menuItems[2].subItems[1].link;
        // this.router.navigate([firstmenu]);
        // }
      } else {
        if (this.roleId == this.roleEnumType.Student) {
          this.sessionService.setLocalStorageWithKey("menu", menuItems);
          this.sessionService.setLocalStorageWithKey("menucontrols", result);
          localStorage.setItem('isLoggedin', 'false');
          localStorage.setItem('isStudentLoggedin', 'true');
          this.toaster.success("Student Logged in Successfully!")
          var url = window.location.origin + "/student/";
          window.location.href = url;
          return;
        } else {
          this.alertService.info("You have no Access, Please contact support team");
        }
      }
    });
  }

  //   lapTopScheme()
  //   {
  //   Swal.fire({
  //   title: 'Info',
  //   html: `
  //     <ul class="text-justify p-0" style="font-size: 14px;color:black">
  //       <li>
  //         <span style="color: red; font-weight: bold;">Kind Attention</span>:
  //         For the first phase of laptop distribution, only Final Year and Pre-Final Year students are eligible. 
  //         Other-year students are requested to wait until the next announcement.
  //       </li><br>
  //     </ul>

  //     <hr>

  //     <div style="text-align:left; font-size:14px; color:black;">

  //   <label><b>Are you studying final year?</b></label>

  //   <div style="display:flex; gap:20px; margin-top:4px;">
  //     <label style="display:flex; align-items:center; gap:5px;">
  //       <input type="radio" name="finalyear" value="yes"> Yes
  //     </label>

  //     <label style="display:flex; align-items:center; gap:5px;">
  //       <input type="radio" name="finalyear" value="no"> No
  //     </label>
  //   </div>

  //   <br>

  //   <label><b>Do you have UMIS Registration ID?</b></label>

  //   <div style="display:flex; gap:20px; margin-top:4px;">
  //     <label style="display:flex; align-items:center; gap:5px;">
  //       <input type="radio" name="umisid" value="yes"> Yes
  //     </label>

  //     <label style="display:flex; align-items:center; gap:5px;">
  //       <input type="radio" name="umisid" value="no"> No
  //     </label>
  //   </div>

  // </div>

  //   `,
  //   icon: "info",
  //   showCancelButton: true,
  //   cancelButtonText: 'Cancel',
  //   confirmButtonColor: '#d33',
  //   cancelButtonColor: '#3085d6',
  //   confirmButtonText: 'Ok',
  //   allowOutsideClick: false,

  //   preConfirm: () => {
  //     const finalYear = document.querySelector('input[name="finalyear"]:checked') as HTMLInputElement;
  //     const umisID = document.querySelector('input[name="umisid"]:checked') as HTMLInputElement;

  //     if (!finalYear || !umisID) {
  //       Swal.showValidationMessage("Please select all options");
  //       return false;
  //     }

  //     return {
  //       finalYear: finalYear.value,
  //       umisID: umisID.value
  //     };
  //   }
  // }).then((result) => {
  //   if (result.isConfirmed && result.value) {
  //     console.log("Final Year:", result.value.finalYear);
  //     console.log("UMIS ID:", result.value.umisID);
  //     if(result.value.finalYear === 'yes')
  //     {
  //     if(result.value.umisID === 'yes')
  //     {
  //       this.GetUmisId();
  //     }
  //     }
  //     else{
  //       this.alertService.warning("Your not eligible for Laptop Scheme");
  //     }
  //   } 

  //   if (result.isDismissed) {
  //     console.log("User clicked Cancel");
  //   }
  // });


  //   }

  // GetUmisId() {
  //     let data = 1
  //     const dialogRef = this.dialog.open(LaptopschemepopupComponent, {
  //       autoFocus: false,
  //       disableClose: true,
  //       width: "50%",
  //       // height: "30%",
  //       panelClass: 'custom-dialog-container',
  //       data: data
  //     });
  //     dialogRef.afterClosed().subscribe((result) => {
  //       debugger
  //       if (result) {
  //       const dialogRef = this.dialog.open(LaptopschemeDataComponent, {
  //       autoFocus: false,
  //       disableClose: true,
  //       width: "100%",
  //       height: "100%",
  //       panelClass: "mat-dialog",
  //       data: {
  //         openKey: 1,
  //       }
  //     });
  //     dialogRef.afterClosed().subscribe((data) => {
  //       if (data) {

  //       }

  //     });
  //       }
  //     });
  //   }
  LaptopGrievanceEligible() {
    this.dataService.getshowBtnhomePage(true).subscribe(res => {
      if (res?.isSuccess) {
        this.showBtn = res?.value
      }
    });
  }
}
